/* global window */

window.dataLayer = window.dataLayer || [];

export const reservationAvailabilityList = (availabilities, currency) => {
  const items = availabilities.map((p, index) => {
    const variant = p.options?.[0];
    return {
      currency,
      item_name: p.title,
      item_id: variant?.sku || p.id,
      price: variant && variant.addToCartPrice / 100,
      item_variant: variant?.title,
      index
    };
  });

  const payload = {
    event: 'view_reservation_availability_list',
    reservation: {
      items
    }
  };
  window.dataLayer.push(payload);
};

export const selectReservation = (reservationCart, currency) => {
  const payload = {
    event: 'select_reservation',
    reservation: {
      items: [
        {
          currency,
          item_name: reservationCart.reservationType.title,
          item_id: reservationCart.reservationTypeOption.sku,
          price: reservationCart.price / 100,
          item_variant: reservationCart.reservationTypeOption.title,
          quantity: reservationCart.guestCount,
          date: reservationCart.reservationDate
        }
      ]
    }
  };
  window.dataLayer.push(payload);
};

export const reservationCheckoutStep = (reservationCart, currency, step) => {
  const reservation = getReservationPayload(reservationCart, currency);

  const payload = {
    event: step,
    reservation
  };
  window.dataLayer.push(payload);
};

export const reservationPurchase = (reservationCart, currency) => {
  const reservation = getReservationPayload(reservationCart, currency);

  reservation.transaction_id = reservationCart.reservationNumber;

  const payload = {
    event: 'reservation_purchase',
    reservation
  };
  window.dataLayer.push(payload);
};

const getReservationPayload = (reservation, currency) => {
  const items = [
    {
      currency,
      item_name: reservation.reservationType.title,
      item_id: reservation.reservationTypeOption.sku,
      price: reservation.price / 100,
      item_variant: reservation.reservationTypeOption.title,
      quantity: reservation.guestCount,
      date: reservation.reservationDate
    }
  ];

  const payload = {
    currency,
    value: (reservation.price * reservation.guestCount) / 100,
    payment_type: reservation.tenderType,
    items
  };

  return payload;
};
